import { createAction, handleActions } from 'redux-actions'

const openNotesModal = createAction('SCREENS/SUB_VALUATION/OPEN_NOTES_MODAL')
const closeNotesModal = createAction('SCREENS/SUB_VALUATION/CLOSE_NOTES_MODAL')

const defaultState = {
  show: false,
}

const reducer = handleActions(
  {
    [openNotesModal]: (state, { payload }) => ({ ...payload, show: true }),
    [closeNotesModal]: () => defaultState,
  },
  defaultState,
)

export { openNotesModal, closeNotesModal, reducer }
